import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CompanyEditForm from '@src/features/tenant/company/CompanyEditForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function CompanyEdit() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <CompanyEditForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default CompanyEdit;
